import * as yup from "yup";

export const checkInSchema = (translate: Function) => yup.object().shape({
	comment: yup.string().required(translate("Comentário é requerido")),
	date: yup.date().typeError(translate("Data é requerido")).required(translate("Data é requerido")),
	value: yup.string().required(translate("Valor é requerido"))
});

export const checkInMilestoneSchema = (translate: Function) => yup.object().shape({
	comment: yup.string().required(translate("Comentário é requerido")),
	date: yup.date().typeError(translate("Data é requerido")).required(translate("Data é requerido"))
});
